import { faBell } from '@fortawesome/free-regular-svg-icons';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef } from 'react';
import { Button } from 'react-bootstrap';
import { IconButton } from '../IconButton/IconButton';
import styles from './Topbar.module.scss';

/** Adatta il pulsante hamburger all'API dei toggle dei menu React Bootstrap. */
const MenuButtonToggle = forwardRef(({ onClick, className, ...props }: any, ref) => (
  <Button
    variant={'outline-light'}
    className={`${styles.menuToggle} borderless ${className || ''}`}
    aria-label={'Apri menu'}
    ref={ref as any}
    {...props}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <FontAwesomeIcon icon={faBars} />
  </Button>
));

const MenuCloseToggle = forwardRef(({ onClick, className, ...props }: any, ref) => (
  <Button
    className={`${styles.menuCloseToggle} ${className || ''}`}
    aria-label={'Chiudi menu'}
    ref={ref as any}
    {...props}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <FontAwesomeIcon icon={faTimes} />
  </Button>
));

/** Adatta il pulsante delle notifiche all'API dei toggle dei menu React Bootstrap. */
const NotificationButtonToggle = forwardRef(({ onClick, children: notificationBadge }: any, _) => (
  <div className={styles.notificationToggle} aria-label={'Notifiche'}>
    <IconButton
      className={`${styles.tootorAppBarIconButton} ${styles.notificationCircle}`}
      icon={faBell}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    />
    {!!notificationBadge && <span className={styles.notificationDot} />}
  </div>
));

export { MenuButtonToggle, MenuCloseToggle, NotificationButtonToggle };
